export const fallbackLocale = 'en';

export const calculateUrlWithNewLocale = (props: any, locale: any) => {
  const { match, location } = props;

  const {
    params: { locale: currentLocale },
  } = match;
  const { pathname: pn, hash, search } = location;

  const pathname = pn + search + hash;

  const localePrefix = locale === fallbackLocale ? '' : `${locale}`;

  if (currentLocale) {
    return pathname
      .replace(new RegExp(currentLocale), localePrefix)
      .replace(new RegExp('//+'), '/');
  }

  if (locale) {
    return `/${locale}${pathname}`;
  }
};

export const calculateNewUrl = (locale: string, newUrl: string) => {
  return `/${locale || ''}/${newUrl}`.replace(new RegExp('//+'), '/');
};
